export default __webpack_public_path__ + "static/media/travolta.b0232c0e.gif";